var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { margin: "20px" } },
    [
      _c(
        "el-form",
        [
          _c(
            "el-row",
            {
              staticStyle: { "flex-wrap": "wrap", "align-items": "center" },
              attrs: { type: "flex", justify: "left" },
            },
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("newOrder.waybillStatus") } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "90%" },
                          attrs: {
                            placeholder: _vm.$t("GlobalSetObj.all"),
                            clearable: "",
                            "collapse-tags": "",
                            filterable: "",
                            multiple: "",
                            size: "small",
                          },
                          model: {
                            value: _vm.wForm.params.waybillStatus,
                            callback: function ($$v) {
                              _vm.$set(_vm.wForm.params, "waybillStatus", $$v)
                            },
                            expression: "wForm.params.waybillStatus",
                          },
                        },
                        _vm._l(_vm.waybillStatusList, function (item, ind) {
                          return _c("el-option", {
                            key: ind,
                            attrs: { label: item.label, value: item.code },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("GlobalSetObj.ProcessingStatus") },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "90%" },
                          attrs: {
                            placeholder: _vm.$t("GlobalSetObj.all"),
                            clearable: "",
                            size: "small",
                          },
                          model: {
                            value: _vm.wForm.params.processingState,
                            callback: function ($$v) {
                              _vm.$set(_vm.wForm.params, "processingState", $$v)
                            },
                            expression: "wForm.params.processingState",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("GlobalSetObj.Pending"),
                              value: 1,
                            },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("collectionCenter.processed"),
                              value: 2,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 7 } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.waybillSearch },
                    },
                    [_vm._v(_vm._s(_vm.$t("newOrder.search")) + " ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: { click: _vm.waybillReset },
                    },
                    [_vm._v(_vm._s(_vm.$t("newOrder.reset")) + " ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.exportExcel },
                    },
                    [_vm._v(_vm._s(_vm.$t("newOrder.export")) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            border: "",
            "max-height": "600",
            data: _vm.detailsTableData,
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("GlobalSetObj.serial"),
              align: "center",
              type: "index",
              width: "70",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("collectionCenter.waybillNumber"),
              prop: "waybillNumber",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("collectionCenter.ScanNumber"),
              prop: "scanNumber",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("GlobalSetObj.ProcessingStatus"),
              prop: "processingStatus",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      [
                        scope.row.processingStatus === 1
                          ? _c("el-tag", { attrs: { type: "success" } }, [
                              _vm._v(_vm._s(_vm.$t("GlobalSetObj.Pending"))),
                            ])
                          : scope.row.processingStatus === 2
                          ? _c("el-tag", [
                              _vm._v(
                                _vm._s(_vm.$t("collectionCenter.processed"))
                              ),
                            ])
                          : _c("span", [_vm._v("--")]),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("collectionCenter.processingResult"),
              prop: "handlingResult",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [
                      _vm._v(
                        " " +
                          _vm._s(
                            scope.row.handlingResult === 1
                              ? _vm.$t(
                                  "collectionCenter.upstreamResponsibility"
                                )
                              : scope.row.handlingResult === 2
                              ? _vm.$t(
                                  "collectionCenter.downstreamResponsibility"
                                )
                              : scope.row.handlingResult === 3
                              ? _vm.$t("GlobalSetObj.blameless")
                              : scope.row.handlingResult === 4
                              ? _vm.$t("home.moreTimeNotReply")
                              : scope.row.handlingResult === 5
                              ? _vm.$t("collectionCenter.partialResponsibility")
                              : "--"
                          ) +
                          " "
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("collectionCenter.shipmentStatus"),
              prop: "waybillStatusName",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("orderCenterCont.zuixinguijineir"),
              prop: "latestTrackContent",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("fixDutyFine.LatestTrackingBranch"),
              prop: "latestTrackSite",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("collectionCenter.loadTime"),
              prop: "loadedTime",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("collectionCenter.loadSiteIdList"),
              prop: "loadedSite",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("collectionCenter.loader"),
              prop: "loadUserName",
              align: "center",
            },
          }),
          _vm.wayId.ticketStatus !== 4 && _vm.wayId.ticketType !== 1
            ? _c("el-table-column", {
                attrs: {
                  label: _vm.$t("newOrder.operation"),
                  align: "center",
                  fixed: "right",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.processingStatus !== 2
                            ? _c(
                                "div",
                                {
                                  staticStyle: {
                                    color: "#2494ff",
                                    cursor: "pointer",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openProcess(scope.row)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("seller.process")))]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1709356404
                ),
              })
            : _vm._e(),
        ],
        1
      ),
      _c("el-pagination", {
        staticStyle: { margin: "10px 0", float: "right" },
        attrs: {
          "current-page": _vm.wForm.pageNumber,
          "page-size": _vm.wForm.pageSize,
          "page-sizes": [10, 50, 100, 500, 1000],
          total: _vm.detailsTotal,
          background: "",
          layout: "total, sizes, prev, pager, next, jumper",
        },
        on: {
          "size-change": _vm.waybillSearch,
          "current-change": _vm.waybillSearch1,
        },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("collectionCenter.processingResult"),
            visible: _vm.pRDialogVisible,
            width: "30%",
            "before-close": _vm.processRClose,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.pRDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                "font-size": "15px",
                "font-weight": "bold",
                color: "#67696d",
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("GlobalSetObj.totalOptions")) + "：1 ")]
          ),
          _c(
            "el-form",
            {
              ref: "pRFormRef",
              staticStyle: { margin: "10px" },
              attrs: { model: _vm.pRForm, "label-position": "top" },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label:
                              _vm.$t("collectionCenter.processingResult") +
                              "：",
                            prop: "handlingResult",
                            rules: [
                              {
                                required: true,
                                message: _vm.$t("GlobalSetObj.pleaseChoose"),
                                trigger: "change",
                              },
                            ],
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "collectionCenter.pleaseChoose"
                                ),
                                clearable: "",
                              },
                              model: {
                                value: _vm.pRForm.handlingResult,
                                callback: function ($$v) {
                                  _vm.$set(_vm.pRForm, "handlingResult", $$v)
                                },
                                expression: "pRForm.handlingResult",
                              },
                            },
                            _vm._l(_vm.processResultList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.processRClose } }, [
                _vm._v(_vm._s(_vm.$t("GlobalSetObj.cancel"))),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.submitProcess },
                },
                [_vm._v(_vm._s(_vm.$t("GlobalSetObj.confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }